import { InjectionKey } from "vue";

export const PublicPageSymbol: InjectionKey<{ isPublic: boolean; token: string | null }> = Symbol();
